var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4c3.314 0 6 2.686 6 6 0 1.944-.924 3.671-2.357 4.768C20.798 16.166 23 19.326 23 23c0 .552-.448 1-1 1s-1-.448-1-1c0-3.866-3.134-7-7-7s-7 3.134-7 7c0 .552-.448 1-1 1s-1-.448-1-1c0-3.674 2.202-6.834 5.357-8.232C8.924 13.67 8 11.944 8 10c0-3.314 2.686-6 6-6zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z",
    transform: "translate(-20 -205) translate(20 205)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.62d551681e062f198ba9a3ad368bd7f8.svg";
export { ForwardRef as ReactComponent };